import { KeyboardEventHandler } from "react";
import { CheckedInput, Container, ExtraPrice, InfoItem, InfoList, Input, OfferContainer, OfferContainerDark, Price, PriceContainer, PriceDefinition, ProductCard, ProductCardContainer, Title, TopContainer, TopContainerLeft, TopContainerRight } from "./ProductCardV2.style";
import { BiCheck } from "react-icons/bi";



interface Props {
    title: string | undefined;
    price: string | undefined;
    extraPrice?: string;
    offerText?: string;
    bottomOfferText?: string;
    hasOffer?: boolean;
    info?: Array<any>;
    removekrPerMonth?: boolean;
    priceUnavailable?: boolean;
    onClick?: () => void;
    isChecked: boolean;
    onKeyDown: KeyboardEventHandler<HTMLDivElement>;
}

export default function ProductCardV2({title, price, extraPrice, offerText, bottomOfferText, hasOffer, info, onClick, isChecked = false, onKeyDown, removekrPerMonth, priceUnavailable}: Props) {
    return (
        <Container>
            <ProductCardContainer isChecked={isChecked}>
            {hasOffer && offerText && offerText != "" && (
                <OfferContainer>{offerText}</OfferContainer>
            )}
                <ProductCard onClick={onClick} isChecked={isChecked} tabIndex={0} onKeyDown={onKeyDown} hasOffer={hasOffer} hasBottomOffer={isChecked && bottomOfferText ? true : false}>
                    <TopContainer>
                    <TopContainerLeft>
                        <Input isChecked={isChecked}>
                            {isChecked && (<CheckedInput/>)}
                        </Input>
                        <Title>{title}</Title>
                    </TopContainerLeft>
                    <TopContainerRight>
                        <PriceContainer>
                        <Price priceUnavailable={priceUnavailable}>
                            {price} {!removekrPerMonth && (<PriceDefinition> kr./md.</PriceDefinition>)}
                        </Price>
                        {extraPrice && 
                        <ExtraPrice>
                            {extraPrice}
                        </ExtraPrice>
                        }
                    </PriceContainer>
                    </TopContainerRight>
                    </TopContainer>
                </ProductCard>
            {isChecked && bottomOfferText && (
                <OfferContainerDark>
                    {bottomOfferText}
                </OfferContainerDark>
            )}
            </ProductCardContainer>
        </Container>
    )
}